module.exports = __webpack_public_path__ + "static/img/credential1.5521a93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credential/credential1.jpg
// module id = gf45
// module chunks = 1